import { AbTestConfiguration, AbTestStorage, abTestsStorageName, getAbTestVariant } from "@allwyn/ab-testing/ab-test";
import { useLocalStorage } from "@allwyn/storage/composables/use-storage";
import { getSettingValue } from "@allwyn/utils/settings-api";

export const consentBarAbTestId = "consent-bar";
const CONSENT_BAR_AB_TEST_SETTING_KEY = "ConsentBarAbTestEnabled";
const CONSENT_BAR_AB_TEST_SETTING_TIMEOUT_MS = 2_000;

export const consentBarVariants = {
    Current: "current",
    Test: "test",
} as const;

export type ConsentBarVariant = (typeof consentBarVariants)[keyof typeof consentBarVariants];

const consentBarAbTest: AbTestConfiguration<typeof consentBarAbTestId, ConsentBarVariant> = {
    testName: consentBarAbTestId,
    variants: [
        { codename: consentBarVariants.Current, userPercentage: 0 },
        { codename: consentBarVariants.Test, userPercentage: 100 },
    ],
};

export const consentBarAbTestStorage: AbTestStorage = {
    read: () => useLocalStorage().getJson<unknown>(abTestsStorageName),
    write: (tests) => {
        return useLocalStorage().setJson(abTestsStorageName, tests, "essential");
    },
};

export const getConsentBarVariant = (isAbTestEnabled: boolean): ConsentBarVariant =>
    isAbTestEnabled ? getAbTestVariant(consentBarAbTest, consentBarAbTestStorage) : consentBarVariants.Current;

export const isConsentBarAbTestEnabled = async (configuredValue?: boolean): Promise<boolean> => {
    if (configuredValue !== undefined) return configuredValue;

    const settingValue = await getSettingValue(CONSENT_BAR_AB_TEST_SETTING_KEY, CONSENT_BAR_AB_TEST_SETTING_TIMEOUT_MS);
    return settingValue?.trim().toLowerCase() === "true";
};
